/**
 * LicenseLocation Component
 */

import './styles.scss';

import { isEqual, sortBy } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import ConnectedLicenseBuilderContainer, {
  LicenseComponentProps,
} from '../../../../../containers/ConnectedLicenseBuilderComponent';

import Heading from '../../../../atoms/text/Heading';
import { Span } from '../../../../atoms/text/Label';
import { mediaTypeDefinitions } from '../../../../organisms/forms/LicenseBuilder/config';
import CheckboxWithLabel from '../../CheckboxWithLabel';
import { LocationCheckbox } from './LocationCheckbox';

type LicenseComponentEdge = GQL.IProducerLocationEdge;
type LicenseComponentNode = GQL.IProducerLocation;
type LicenseComponentOwnProps = LicenseComponentProps<LicenseComponentEdge>;

const classes = new BEM('license-builder__step');

class LicenseLocation extends React.Component<LicenseComponentOwnProps, {}> {
  private commonLocations: LicenseComponentNode[];
  private countryLocations: LicenseComponentNode[];

  constructor(props) {
    super(props);

    this.sortLocations();
  }

  componentWillReceiveProps(nextProps: LicenseComponentOwnProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.sortLocations(nextProps);
    }
  }

  shouldComponentUpdate(nextProps: LicenseComponentOwnProps) {
    return !isEqual(nextProps.selectedParam, this.props.selectedParam) ||
      nextProps.editingUsageIndex === this.props.editingUsageIndex;
  }

  onSelectLocation = (component: ILicenseComponent) => {
    this.props.setParam(this.isLocationSet(component.id) ? null : [component]);
  }

  renderList(list: LicenseComponentNode[], title?: string) {
    return !!list.length && (
      <ul data-title={title}>
        {list.map(({ internal_id: id, name }) => (
          <li key={`${this.props.editingUsageIndex}-${id!}`}>
            <LocationCheckbox
              checked={this.isLocationSet(id!)}
              id={id as LicenseProducerLocationTypeIdentifier}
              name={name}
              onChange={this.onSelectLocation}
            />
          </li>
        ))}
      </ul>
    );
  }

  renderCheckbox(id: LicenseProducerLocationTypeIdentifier, name: string) {
    const component: ILicenseComponent = { id, name };
    return (
      <CheckboxWithLabel
        checked={this.isLocationSet(id)}
        onChange={() => {
          this.onSelectLocation(component);
        }}
        label={name}
        name={`location[${id}]`}
      />
    );
  }

  render() {
    const { medium } = this.props;
    const mediumDefinition = mediaTypeDefinitions.find((v) => v.id === medium);

    let locationSubtitle: string | undefined;
    if (mediumDefinition) {
      locationSubtitle = mediumDefinition.contextualSubtitle;
    }

    return (
      <div {...classes('', 'location') }>
        <Heading
          is="h4"
          {...classes('title') }
        >Your Location:
        </Heading>
        <Span size="medium" variant="note" {...classes('note')}>{locationSubtitle}</Span>
        {this.renderList(this.commonLocations, 'Commonly Used')}
        {this.renderList(this.countryLocations, 'All Countries')}
      </div>
    );
  }

  private isLocationSet(locationId: number) {
    const selectedLocation = this.props.selectedParam && this.props.selectedParam[0] as ILicenseComponent | null;
    return !!selectedLocation && selectedLocation.id === locationId;
  }

  private sortLocations(props: LicenseComponentOwnProps = this.props) {
    this.commonLocations = [];
    this.countryLocations = [];

    props.data.forEach((edge) => {
      const node = edge.node!;
      const { name } = node;

      if (['United States of America', 'Canada', 'France'].indexOf(name) > -1) {
        this.commonLocations.push(node);
      } else {
        this.countryLocations.push(node);
      }
    });

    this.commonLocations = sortBy(this.commonLocations, 'name');
    this.countryLocations = sortBy(this.countryLocations, 'name');
  }
}

const ConnectedLicenseLocation =
  ConnectedLicenseBuilderContainer<LicenseComponentEdge>(LicenseLocation, 'contextual_param');

export default ConnectedLicenseLocation;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectLocation/index.tsx